import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patientstatus',
  templateUrl: './patientstatus.component.html',
  styleUrls: ['./patientstatus.component.css']
})
export class PatientstatusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/patientstatus/patientstatus.component.ts